/*
 *  fix [maxlength] attribute behavior on Android
 */

export function processInput(e) {
    if (e.target.value.length > e.target.maxLength) {
        e.target.value = e.target.value.slice(0, e.target.maxLength);
    }
}

export default {
    inserted(el) {
        if (el.maxLength && el.maxLength > 0) {
            el.addEventListener('input', processInput);
        }
    },
    unbind(el) {
        if (el.maxLength && el.maxLength > 0) {
            el.removeEventListener('input', processInput);
        }
    }
};
